<template>
	<div
		:class="classes"
		class="cursor-pointer"
		@click="clickHandler"
	>
		<EyeIcon
			v-if="isOpen"
			class="h-6 text-won-dark"
		/>
		<EyeSlashIcon
			v-else
			class="h-6 text-won-dark"
		/>
	</div>
</template>

<script setup>
import { EyeIcon, EyeSlashIcon } from '@heroicons/vue/24/solid';

const emit = defineEmits(['trigger-show']);
defineProps({
	classes: {
		type: String,
		default: ''
	},
	isOpen: {
		type: Boolean,
		default: true
	}
});

const clickHandler = () => {
	emit('trigger-show');
};
</script>
